import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { AddUserDialogComponent } from '../../add-user-dialog/add-user-dialog.component';
import { TreeCheckedNode } from 'shared';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatTreeNestedDataSource } from '@angular/material/tree';
import { ExampleFlatNode, FoodNode } from 'shared';
import { SelectionModel } from '@angular/cdk/collections';
import { SelectData } from 'shared';

// const PROJECTS: TreeCheckedNode[] = [
//   {
//     id: 'p1',
//     name: 'Projekt1',
//     checked: true,
//     isParent: true,
//     children: [{id: 'pgr1', name: 'PGR11', checked: true, isParent: false}, {id: 'pgr2', name: 'PGR12', checked: true, isParent: false}, {id: 'pgr1', name: 'PGR13', checked: true, isParent: false}],
//   },
//   {
//     id: 'p2',
//     name: 'Projekt2',
//     checked: true,
//     isParent: true,
//     children: [
//       {
//         id: 'pgr3',
//         name: 'PGR21',
//         checked: true,
//         isParent: false
//       },
//       {
//         id: 'pgr4',
//         name: 'PGR22',
//         checked: true,
//         isParent: false
//       },
//     ],
//   },
// ];

@Component({
    selector: 'app-select-userpermission-dialog',
    templateUrl: './select-userpermission-dialog.component.html',
    styleUrls: ['./select-userpermission-dialog.component.scss'],
    standalone: false
})

export class SelectUserpermissionDialogComponent implements OnInit {

  //alt
  // private _transformer = (node: TreeCheckedNode, level: number) => {
  //   return {
  //     expandable: !!node.children && node.children.length > 0,
  //     name: node.name,
  //     // id: node.id,
  //     level: level,
  //   };
  // };
  treeControl = new NestedTreeControl<TreeCheckedNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<TreeCheckedNode>();
  // treeFlattener = new MatTreeFlattener(
  //   this._transformer,
  //   node => node.level,
  //   node => node.expandable,
  //   node => node.children,
  // );
  hasChild = (_: number, node: TreeCheckedNode) => !!node.children && node.children.length > 0;

  //neu
  // treeControl = new NestedTreeControl<TreeCheckedNode>(node => node.children);
  // dataSource = new MatTreeNestedDataSource<TreeCheckedNode>();
  checklistSelection = new SelectionModel<TreeCheckedNode>(true /* multiple */);
  // hasChild = (_: number, node: TreeCheckedNode) => !!node.children && node.children.length > 0;

  anzAllProjRolePairs = 0;
  isNoTemplate = false;
  isNoRoles = false;
  allDataLoaded = false;
  selectAllTemplates = false;
  selectTemplatesWithoutAdmin = false;
  selectUserPermissions = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    // public _dialogRef: MatDialogRef<AddUserDialogComponent>,
    public _dialogRef: MatDialogRef<SelectUserpermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectData, // source userId (von diesem User wird übernommen)
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService
  ) { }

  ngOnInit() {
    console.log("-----> select-userpermission: ngOnInit - data = ", this.data);
    if(this.data.action == "selectTemplates"){
      // es handelt sich um die Selektion der Projekt Vorlagen (ohne Vorlagen für Admin)
      this.tenantService.getTenantProjectGroupRoleTemplatesChecked(this.data.tenantName).subscribe({
        next: (treeNode: TreeCheckedNode[]) => {
          // console.log("----------> select-userpermission: treeNode[0] = ", treeNode[0]);
          this.selectTemplatesWithoutAdmin = true;
          this.allDataLoaded = true;
          if(treeNode.length == 1 && (treeNode[0].children == null || treeNode[0].children.length == 0)){
            this.isNoTemplate = true;
            return;
          }
          // console.log("-----> select-userpermission: treeNode = ", treeNode)
          this.dataSource.data = treeNode;
          const allProjRolePairs = this.getCheckedNodeIds();
          this.anzAllProjRolePairs = allProjRolePairs.length;

          //this.toggleCheck(this.dataSource.data[0]);
          this.treeControl.expand(treeNode[0]);
          console.log('Alle Proj Role Templates IDs:', this.anzAllProjRolePairs);    
        },
        error: (error: any) => {
          //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
        }
      });
    } else if (this.data.action == "selectAllTemplates"){
      // es handelt sich um die Selektion aller Projekt Vorlagen (incl. Vorlagen für Admin)
      this.tenantService.getAllTenantProjectGroupRoleTemplatesChecked(this.data.tenantName).subscribe({
        next: (treeNode: TreeCheckedNode[]) => {
          // console.log("----------> select-userpermission: treeNode[0] = ", treeNode[0]);
          this.selectAllTemplates = true;
          this.allDataLoaded = true;
          if(treeNode.length == 1 && (treeNode[0].children == null || treeNode[0].children.length == 0)){
            this.isNoTemplate = true;
            return;
          }
          // console.log("-----> select-userpermission: treeNode = ", treeNode)
          this.dataSource.data = treeNode;
          const allProjRolePairs = this.getCheckedNodeIds();
          this.anzAllProjRolePairs = allProjRolePairs.length;

          //this.toggleCheck(this.dataSource.data[0]);
          this.treeControl.expand(treeNode[0]);
          console.log('Alle Proj Role Templates IDs:', this.anzAllProjRolePairs);    
        },
        error: (error: any) => {
          //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
        }
      });
    } 
    else{
      // userId ist gesetzt ==> es handelt sich um die Selektion der Projekt Rollen für den User
      console.log("----------> select-userpermission: from userId ", this.data)
      this.tenantService.getUserProjectsAndGrouprolesChecked(this.tenantService.tempTenantName, this.data.userId).subscribe({
        next: (treeNode: TreeCheckedNode[]) => {
      // this.tenantService.getUserProjectsAndGrouproles(this.tenantService.tempTenantName, this.data).subscribe({
      //   next: (treeNode: FoodNode[]) => {
          // console.log("-----> select-userpermission: treeNode = ", treeNode)
          this.selectUserPermissions = true;
          this.allDataLoaded = true;
          // if(treeNode.length == 0 && (treeNode[0].children == null || treeNode[0].children.length == 0)){
          if(treeNode.length == 0){
            this.isNoRoles = true;
            return;
          }
          this.dataSource.data = treeNode;
          const allProjRolePairs = this.getCheckedNodeIds();
          this.anzAllProjRolePairs = allProjRolePairs.length;
          console.log('Alle Proj Role IDs:', this.anzAllProjRolePairs);    
        },
        error: (error: any) => {
          //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
        }
      });
    }

  }

  //alt
  toggleCheck(node: TreeCheckedNode) {
    node.checked = !node.checked;
    if (node.children) {
      this.toggleChildrenCheck(node, node.checked);
    }
    this.updateTreeNodeStatus(node, this.getParentNode(node));
    }

  toggleChildrenCheck(node: TreeCheckedNode, checked: boolean) {
    node.children?.forEach(child => {
      child.checked = checked;
      this.toggleChildrenCheck(child, checked);
    });
  }

  updateTreeNodeStatus(node: TreeCheckedNode, parent?: TreeCheckedNode) {
    // Wenn der aktuelle Knoten ein Child ist, aktualisiere seinen Parent
    if (parent) {
      this.updateParentStatus(parent);
    }
  
    // Falls der Knoten Kinder hat, prüfe ihre Zustände
    if (node.children) {
      node.children.forEach((child) => {
        this.updateTreeNodeStatus(child, node);
      });
    }
  }

  updateParentStatus(node: TreeCheckedNode) {
    if (node.children) {
      // Prüfe, ob alle Child-Knoten deaktiviert sind
      const allChildrenUnchecked = node.children.every((child) => !child.checked);
  
      // Aktualisiere den Status des Parent-Knotens
      node.checked = !allChildrenUnchecked;
    }
  }
  
  getParentNode(node: TreeCheckedNode): TreeCheckedNode | undefined {
    let parent: TreeCheckedNode | null = null;
  
    const findParent = (currentNode: TreeCheckedNode, currentParent: TreeCheckedNode | null) => {
      if (currentNode === node) {
        parent = currentParent;
        return;
      }
      if (currentNode.children) {
        currentNode.children.forEach((child) => findParent(child, currentNode));
      }
    };
  
    this.dataSource.data.forEach((rootNode) => findParent(rootNode, null));
    return (parent != null)?parent:undefined;
  }
  
  //neu

    /** Ob alle Kinder ausgewählt sind */
  descendantsAllSelected(node: TreeCheckedNode): boolean {
    const descendants = this.getDescendants(node);
    return descendants.length > 0 && descendants.every(child => this.checklistSelection.isSelected(child));
  }

  /** Ob nur ein Teil der Kinder ausgewählt ist */
  descendantsPartiallySelected(node: TreeCheckedNode): boolean {
    const descendants = this.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Klick auf ein Parent-Node */
  todoItemSelectionToggle(node: TreeCheckedNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.getDescendants(node);
    if (this.checklistSelection.isSelected(node)) {
      this.checklistSelection.select(...descendants);
    } else {
      this.checklistSelection.deselect(...descendants);
    }
  }

  /** Klick auf ein Child-Node */
  todoLeafItemSelectionToggle(node: TreeCheckedNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /** Prüfen ob Eltern aktualisiert werden müssen */
  checkAllParentsSelection(node: TreeCheckedNode): void {
    let parent: TreeCheckedNode | null = this.getParent(node);
    while (parent) {
      this.updateParentSelection(parent);
      parent = this.getParent(parent);
    }
  }

  updateParentSelection(node: TreeCheckedNode): void {
    const descendants = this.getDescendants(node);
    if (descendants.every(child => this.checklistSelection.isSelected(child))) {
      this.checklistSelection.select(node);
    } else if (descendants.every(child => !this.checklistSelection.isSelected(child))) {
      this.checklistSelection.deselect(node);
    }
  }

  /** Hilfsfunktionen (je nach Struktur anpassen) */
  getDescendants(node: TreeCheckedNode): TreeCheckedNode[] {
    const descendants: TreeCheckedNode[] = [];
    if (node.children) {
      node.children.forEach(child => {
        descendants.push(child, ...this.getDescendants(child));
      });
    }
    return descendants;
  }

  getParent(node: TreeCheckedNode): TreeCheckedNode | null {
    let parent: TreeCheckedNode | null = null;
    this.dataSource.data.forEach(root => {
      if (this.findParent(root, node)) {
        parent = this.findParent(root, node);
      }
    });
    return parent;
  }

  private findParent(parent: TreeCheckedNode, child: TreeCheckedNode): TreeCheckedNode | null {
    if (!parent.children) return null;
    if (parent.children.indexOf(child) > -1) return parent;
    for (let p of parent.children) {
      const found = this.findParent(p, child);
      if (found) return found;
    }
    return null;
  }
  
  cancel(){
    this._dialogRef.close();
  }
  add(){
      const checkedProjRolePairs = this.getCheckedNodeIds();
      console.log('Aktivierte Proj Role IDs:', checkedProjRolePairs.length);    
      this._dialogRef.close(checkedProjRolePairs);
    }

    //alt
    getCheckedNodeIds(): string[] {
    const projRolePairs: string[] = [];
    let parentId: string = "";
  
    const collectCheckedIds = (nodes: TreeCheckedNode[]) => {
      nodes.forEach((node) => {
        //console.log("-----> getCheckedNodeIds: each Node = ",node)
        if (node.checked) {
          if (node.isParent) {
            parentId = node.id;
          }
          else {
            //console.log("-----> getCheckedNodeIds: parentId != node.id? " ,parentId + " " + node.id)
            if (parentId != node.id) {
              //console.log("-----> getCheckedNodeIds: Pairs push = ", parentId+"|"+node.id+"|"+node.name)
              projRolePairs.push(parentId+"|"+node.id+"|"+node.name);
            }
          }
        }
        if (node.children) {
          collectCheckedIds(node.children); 
        }
      });
    };
  
    collectCheckedIds(this.dataSource.data); 
    return projRolePairs;
  }

  //neu
  // getCheckedNodeIds(): string[] {
  //   const projRolePairs: string[] = [];
  //   let parentId: string = "";
  //   let parentName: string = "";
  //   const selectedNodes = this.checklistSelection.selected;

  //   console.log("-----> getCheckedNodeIds: selectedNodes = ", selectedNodes);

  //   selectedNodes.forEach((node) => {
  //     if (node.children && node.children.length > 0) {
  //       // Es ist ein Parent-Node
  //       parentId = node.id;
  //     } else {
  //       // Es ist ein Child-Node
  //       if (parentId && parentId !== node.id) {
  //         projRolePairs.push(parentId + "|" + node.id + "|" + node.name);
  //       }
  //     }
  //       // if (node.children) {
  //       //   collectCheckedIds(node.children); 
  //       // }
  //   });

    // const collectCheckedIds = (nodes: FoodNode[]) => {
    //   nodes.forEach((node) => {
    //     //console.log("-----> getCheckedNodeIds: each Node = ",node)
    //     if (node.checked) {
    //       if (node.isParent) {
    //         parentId = node.id;
    //       }
    //       else {
    //         //console.log("-----> getCheckedNodeIds: parentId != node.id? " ,parentId + " " + node.id)
    //         if (parentId != node.id) {
    //           //console.log("-----> getCheckedNodeIds: Pairs push = ", parentId+"|"+node.id+"|"+node.name)
    //           projRolePairs.push(parentId+"|"+node.id+"|"+node.name);
    //         }
    //       }
    //     }
    //     if (node.children) {
    //       collectCheckedIds(node.children); 
    //     }
    //   });
    // };
  
    // collectCheckedIds(this.dataSource.data); 
  //   return projRolePairs;
  // }
}
